/*
 * R24 Konto — Anmelde-Einstieg rund um Shopifys native Account-Komponente.
 *
 * Vertrag: docs/KONTO-LOGIN.md · Waechter: scripts/account-login.contract.test.mjs
 *
 *   1. Keine eigene Anmeldung. Google, Shop, Facebook, E-Mail-Code und das
 *      freiwillige Newsletter-Haekchen liefert <shopify-account> (Shopify steuert
 *      Anbieter und Ablauf). Dieses Skript OEFFNET nur dessen Anmeldefenster —
 *      oder, wenn die Komponente nicht bereitsteht, die Shopify-Anmeldeseite mit
 *      Ruecksprung auf dieselbe Seite (routes.storefront_login_url).
 *   2. Hinweis nur fuer Gaeste, oben links unter dem Kopf, 5 s nach dem Seitenaufbau.
 *      Owner-Regel 24.09.2026 (je Besuch = Browser-Sitzung): 1× beim Betreten des Shops,
 *      1× auf der ersten Produktseite, 1× im Warenkorb — je Seite hoechstens einmal.
 *      Schliesst der Kunde ihn (× / „Später“), erscheint er in DIESEM Besuch nicht mehr;
 *      beim naechsten Besuch wieder. Nie Editor/Konto-/Passwortseiten. Nicht-modal.
 *      E-Mail-Weg: Feld mit autocomplete="email" (der BROWSER bietet dem Kunden seine
 *      gespeicherten Adressen an — wir lesen nichts aus) → Shopifys offizielle Anmelde-
 *      Route mit dokumentiertem `login_hint` (routes.storefront_login_url + &login_hint=)
 *      → Shopify schickt den 6-stelligen Code. Die Adresse wird nie gespeichert/gesendet.
 *   3. Daten: nur sessionStorage (endet mit dem Besuch): r24_login_s = welche Anlaesse
 *      (site/product/cart) schon gezeigt wurden + ob geschlossen; r24_login_c = welcher
 *      Kontext eine Anmeldung begann (30 min). Keine E-Mail, kein Name, keine Kennung.
 *   4. Analyse: Shopify.analytics.publish → Kundenereignisse (Web-Pixel). Shopify
 *      gibt sie nur an Pixel weiter, deren Einwilligung vorliegt. Nutzdaten nur
 *      source/device/trigger/variant/method — nie E-Mail, Name, Code, Token.
 *      `method` ist der WEG (natives Fenster | Weiterleitung), NICHT der Anbieter:
 *      Google/Shop/E-Mail waehlt der Kunde in Shopifys Fenster — das Theme sieht es nicht.
 */
(function () {
  'use strict';

  var s = document.currentScript;
  if (!s || window.R24Account) return;
  var isCustomer = s.getAttribute('data-customer') === '1';
  var loginUrl = s.getAttribute('data-login-url') || '/customer_authentication/login';
  var template = s.getAttribute('data-template') || '';
  var firstName = s.getAttribute('data-first-name') || '';
  var profileUrl = s.getAttribute('data-profile-url') || '';
  var profileIncomplete = s.getAttribute('data-profile-incomplete') === '1';
  var designMode = s.getAttribute('data-design-mode') === '1';

  var DELAY_MS = 5000;          // Owner 24.09.2026: 5 s sichtbare Zeit nach dem Seitenaufbau, ohne Interaktion
  // Produktseite/Warenkorb (01.11.2026): erst nach echtem Interesse — 50 % gescrollt ODER 25 s sichtbare Zeit —
  // und nie, solange der Hinweis Galerie oder Kaufknopf verdecken wuerde (er wartet dann aufs naechste Scrollen).
  var INTEREST_MS = 25000, INTEREST_SCROLL = 0.5;
  var PENDING_MS = 30 * 60000;  // so lange gilt ein Anmeldestart als offen
  var S_KEY = 'r24_login_s', C_KEY = 'r24_login_c';
  // Frueherer 14-Tage-Speicher (bis 24.09.2026) — wird nicht mehr genutzt, einmal aufraeumen.
  try { localStorage.removeItem('r24_login_p'); } catch (e) { /* Speicher gesperrt */ }
  var MAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  /* ------------------------------------------------------------ helpers -- */
  function warn(what, e) { if (typeof console !== 'undefined') console.warn('[R24 Konto] ' + what, e); }
  function device() {
    try { return window.matchMedia('(max-width:749px)').matches ? 'mobile' : 'desktop'; } catch (e) { return 'desktop'; }
  }
  function read(area, key) {
    try { var v = JSON.parse(window[area].getItem(key) || 'null'); return v && typeof v === 'object' ? v : null; }
    catch (e) { return null; }   // Speicher gesperrt/kaputt → wie „nie gezeigt“
  }
  function write(area, key, val) {
    try { if (val === null) window[area].removeItem(key); else window[area].setItem(key, JSON.stringify(val)); }
    catch (e) { /* Speicher gesperrt: Hinweis gilt nur fuer diese Seite — tragbare Degradierung */ }
  }
  // Kundenereignis fuer Web-Pixel (Admin → Kundenereignisse). Shopify prueft die Einwilligung je Pixel.
  function emit(name, data) {
    var d = { source: '', device: device() };
    for (var k in data) if (Object.prototype.hasOwnProperty.call(data, k)) d[k] = data[k];
    try {
      var a = window.Shopify && window.Shopify.analytics;
      if (a && typeof a.publish === 'function') a.publish(name, d);
    } catch (e) { warn('Ereignis ' + name, e); }
  }

  /* ------------------------------------------------ Anmeldung beginnen -- */
  // Quelle = Einstieg im Theme (header, mobile_menu, bottom_tab, cart, smart_prompt);
  // trigger nur beim Hinweis (site, product, cart).
  function startData(src, trig, method) {
    var d = { source: src, method: method };
    if (trig) d.trigger = trig;
    return d;
  }
  function markPending(src, trig, method) {
    write('sessionStorage', C_KEY, { s: String(src || '').slice(0, 24), g: String(trig || '').slice(0, 24), m: method, t: Date.now() });
  }
  function redirect(src, trig) {
    if (!isCustomer) {   // Kunden: Rueckfall = Konto-Seite, keine Anmeldung → kein login_start
      markPending(src, trig, 'redirect');
      emit('login_start', startData(src, trig, 'redirect'));
    }
    location.href = loginUrl;
  }
  function nativeEl() { return document.querySelector('shopify-account'); }
  function whenDefined(ms) {
    if (!window.customElements) return Promise.resolve(false);
    if (customElements.get('shopify-account')) return Promise.resolve(true);
    return new Promise(function (res) {
      var t = setTimeout(function () { res(false); }, ms);
      customElements.whenDefined('shopify-account').then(function () { clearTimeout(t); res(true); });
    });
  }
  function sheetButton(el) {
    var r = el && el.shadowRoot;
    if (!r) return null;
    return r.querySelector('button[popovertarget], button[aria-haspopup]') || r.querySelector('button');
  }
  var opening = false;
  /** Oeffnet Shopifys Anmeldefenster; faellt auf die Anmeldeseite (mit Ruecksprung) zurueck. */
  function open(src, trig) {
    src = src || 'header';
    hidePrompt(false);
    if (opening) return;
    // Mobil-Schublade zuerst schliessen (sie ist modal und haelt den Fokus).
    var md = document.querySelector('#r24md.is-open [data-r24md-close]');
    if (md) md.click();
    var el = nativeEl();
    if (!el) { redirect(src, trig); return; }
    opening = true;
    // Seite fertig geladen und trotzdem keine Komponente → nicht lange warten lassen.
    whenDefined(document.readyState === 'complete' ? 800 : 3500).then(function (ok) {
      opening = false;
      var b = ok && sheetButton(el);
      if (!b) { redirect(src, trig); return; }
      el.setAttribute('data-r24-source', src);
      if (trig) el.setAttribute('data-r24-trigger', trig);
      b.click();
    });
  }

  // Jedes Oeffnen des nativen Fensters (auch der direkte Klick aufs Avatar-Symbol).
  document.addEventListener('open', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('shopify-account')) return;
    hidePrompt(false);
    // Fenster unter dem Knopf verankern (Kopf ist klebend und unterschiedlich hoch).
    var bottom = Math.max(0, Math.round(el.getBoundingClientRect().bottom));
    el.style.setProperty('--r24-acc-top', bottom + 'px');
    var src = el.getAttribute('data-r24-source') || 'header';
    var trig = el.getAttribute('data-r24-trigger') || '';
    el.removeAttribute('data-r24-source'); el.removeAttribute('data-r24-trigger');
    if (isCustomer) { emit('account_menu_open', { source: src }); return; }
    markPending(src, trig, 'native_sheet');
    emit('login_start', startData(src, trig, 'native_sheet'));
  }, true);

  // Einstiege im Theme: jedes [data-r24-login="<kontext>"] (Link auf die Anmeldeseite) und
  // die Beschriftung neben dem Kopf-Symbol ([data-r24-acc], auch fuer Kunden → Konto-Menue).
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    // Klick IN der definierten Komponente (auch unser eigener b.click()) → Shopify ist zustaendig.
    // Ohne diese Weiche loeste der gespiegelte Klick open() erneut aus (Schleife).
    var host = t.closest('shopify-account');
    if (host && window.customElements && customElements.get('shopify-account')) return;
    var a = t.closest('[data-r24-login]') || t.closest('[data-r24-acc]');
    if (!a || (isCustomer && !a.hasAttribute('data-r24-acc'))) return;
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    open(a.getAttribute('data-r24-login') || 'header', '');
  });

  window.R24Account = { open: open };

  // Eingeloggte oeffnen „Mein Konto“ als Konto-Schublade (assets/r24-mobile-drawers.js, alle Breiten). Deren
  // Capture-Listener am document stoppt den Klick — darum hier am window (Capture laeuft window → document).
  if (isCustomer) {
    window.addEventListener('click', function (e) {
      var t = e.target;
      var o = t && t.closest && t.closest('.r24hd-act--acc, [data-r24-tab="account"]');
      if (!o || e.button > 0) return;
      emit('account_menu_open', { source: o.hasAttribute('data-r24-tab') ? 'bottom_tab' : 'header' });
    }, true);
  }

  /* ------------------------------------------------------- Oberflaeche -- */
  var CSS =
    '.r24lp{position:fixed;z-index:130;left:max(16px,env(safe-area-inset-left,0px));top:96px;' +
    'width:min(392px,calc(100vw - 32px));box-sizing:border-box;background:#fff;color:var(--r24h-ink,#16181d);' +
    'border:1px solid rgba(16,24,32,.08);border-radius:18px;box-shadow:0 24px 64px -12px rgba(16,24,32,.28),0 2px 6px rgba(16,24,32,.06);' +
    'padding:22px 22px 16px;font-family:var(--r24h-font,inherit);overflow:hidden;' +
    'opacity:0;transform:translateY(-8px) scale(.985);transform-origin:top left;' +
    'transition:opacity var(--r24-dur,220ms) var(--r24-ease,ease),transform var(--r24-dur,220ms) var(--r24-ease,ease),top .2s ease}' +
    '.r24lp::before{content:"";position:absolute;inset:0 0 auto 0;height:4px;background:linear-gradient(90deg,var(--r24h-green,#0a7c42),#1f9d5c)}' +
    '.r24lp.is-in{opacity:1;transform:none}' +
    '.r24lp__x{position:absolute;top:8px;right:8px;width:40px;height:40px;display:flex;align-items:center;justify-content:center;' +
    'background:none;border:0;border-radius:999px;color:var(--r24h-muted,#5b6470);cursor:pointer}' +
    '.r24lp__x::after{content:"";position:absolute;inset:-2px}' +
    '.r24lp__eye{display:flex;align-items:center;gap:6px;margin:0 44px 8px 0;font-size:var(--r24-fs-xs,12px);font-weight:600;' +
    'letter-spacing:.06em;text-transform:uppercase;color:var(--r24h-green,#0a7c42)}' +
    '.r24lp__eye svg{width:14px;height:14px}' +
    '.r24lp__t{margin:0 40px 4px 0;font-family:var(--r24h-display,inherit);font-size:22px;font-weight:500;line-height:1.2;letter-spacing:-.01em}' +
    '.r24lp__d{margin:0 0 16px;font-size:var(--r24-fs-sm,14px);line-height:1.5;color:var(--r24h-muted,#5b6470)}' +
    '.r24lp__prov{display:grid;gap:8px;min-height:44px}' +
    '.r24lp__sk{height:44px;border-radius:12px;background:linear-gradient(90deg,#f1f3f2 25%,#e8ebea 50%,#f1f3f2 75%);background-size:200% 100%;' +
    'animation:r24lpsk 1.2s linear infinite}' +
    '@keyframes r24lpsk{to{background-position:-200% 0}}' +
    '.r24lp__pb{position:relative;display:flex;align-items:center;justify-content:center;gap:10px;width:100%;min-height:46px;box-sizing:border-box;' +
    'padding:0 16px;border-radius:12px;border:1px solid transparent;font:inherit;font-size:15px;font-weight:600;cursor:pointer;' +
    'transition:filter .15s ease,box-shadow .15s ease,background .15s ease}' +
    '.r24lp__pb svg{position:absolute;left:14px;top:50%;transform:translateY(-50%);width:20px;height:20px}' +
    '.r24lp__pb--google{background:#fff;color:#1f1f1f;border-color:#dadce0;box-shadow:0 1px 2px rgba(60,64,67,.12)}' +
    '.r24lp__pb--shop{background:#5a31f4;color:#fff}' +
    '.r24lp__pb--shop b{font-weight:800;letter-spacing:-.02em}' +
    '.r24lp__pb--facebook{background:#1877f2;color:#fff}' +
    '.r24lp__pb--apple{background:#000;color:#fff}' +
    '.r24lp__pb--more{background:#fff;color:var(--r24h-ink,#16181d);border-color:rgba(0,0,0,.16)}' +
    '.r24lp__or{display:flex;align-items:center;gap:10px;margin:16px 0 12px;font-size:var(--r24-fs-xs,12px);' +
    'color:var(--r24h-muted,#5b6470)}' +
    '.r24lp__or::before,.r24lp__or::after{content:"";flex:1;height:1px;background:rgba(0,0,0,.09)}' +
    '.r24lp__lbl{position:absolute;width:1px;height:1px;overflow:hidden;clip-path:inset(50%);white-space:nowrap}' +
    '.r24lp__row{display:flex;gap:8px}' +
    '.r24lp__in{flex:1;min-width:0;min-height:46px;box-sizing:border-box;padding:0 14px;border:1.5px solid rgba(0,0,0,.16);' +
    'border-radius:12px;background:#fff;font:inherit;font-size:16px;color:inherit}' +
    '.r24lp__in:focus{outline:0;border-color:var(--r24h-green,#0a7c42);box-shadow:0 0 0 3px rgba(10,124,66,.15)}' +
    '.r24lp__in[aria-invalid=true]{border-color:var(--r24h-red-ink,#b91c1c)}' +
    '.r24lp__go{flex:none;min-height:46px;padding:0 18px;border:0;border-radius:12px;background:var(--r24h-green,#0a7c42);color:#fff;' +
    'font:inherit;font-size:15px;font-weight:600;cursor:pointer;white-space:nowrap}' +
    '.r24lp__tip{margin:8px 0 0;font-size:var(--r24-fs-xs,12px);line-height:1.45;color:var(--r24h-muted,#5b6470)}' +
    '.r24lp__err{margin:8px 0 0;font-size:var(--r24-fs-sm,14px);color:var(--r24h-red-ink,#b91c1c)}' +
    '.r24lp__code{display:flex;gap:8px;align-items:flex-start;margin:12px 0 0;padding:10px 12px;border-radius:12px;' +
    'background:var(--r24h-green-wash,#eef6f1);font-size:13px;line-height:1.45;color:var(--r24h-ink,#16181d)}' +
    '.r24lp__code svg{flex:none;width:16px;height:16px;margin-top:1px;color:var(--r24h-green,#0a7c42)}' +
    '.r24lp__foot{display:flex;align-items:center;justify-content:space-between;gap:12px;margin-top:12px}' +
    '.r24lp__later{min-height:44px;padding:0 4px;background:none;border:0;font:inherit;font-size:var(--r24-fs-sm,14px);font-weight:600;' +
    'color:var(--r24h-muted,#5b6470);cursor:pointer}' +
    '.r24lp__fine{margin:0;font-size:11.5px;line-height:1.4;color:var(--r24h-muted,#5b6470);text-align:right}' +
    '.r24lp :focus-visible{outline:2px solid var(--r24h-green-dark,#086434);outline-offset:2px}' +
    // Zustaende ausdruecklich setzen: Kalles' globale Regel „button:hover{color;background-color;border-color}“
    // (Spezifitaet 0,1,1) faerbte sonst beim Ueberfahren um — „Weiter mit Google“ wurde weiss auf hell (24.09.2026).
    '.r24lp .r24lp__pb--google:is(:hover,:focus,:active){background:#f8faff;color:#1f1f1f;border-color:#b9c9ee}' +
    '.r24lp .r24lp__pb--shop:is(:hover,:focus,:active){background:#4a24d6;color:#fff;border-color:transparent}' +
    '.r24lp .r24lp__pb--facebook:is(:hover,:focus,:active){background:#1464cf;color:#fff;border-color:transparent}' +
    '.r24lp .r24lp__pb--apple:is(:hover,:focus,:active){background:#262626;color:#fff;border-color:transparent}' +
    '.r24lp .r24lp__pb--more:is(:hover,:focus,:active){background:#f6f8f7;color:var(--r24h-ink,#16181d);border-color:var(--r24h-green,#0a7c42)}' +
    '.r24lp .r24lp__go:is(:hover,:focus,:active){background:var(--r24h-green-dark,#086434);color:#fff;border-color:transparent}' +
    '.r24lp .r24lp__later:is(:hover,:focus,:active){background:none;color:var(--r24h-ink,#16181d);border-color:transparent}' +
    '.r24lp .r24lp__x:is(:hover,:focus,:active){background:#e7eae8;color:var(--r24h-ink,#16181d);border-color:transparent}' +
    // Schliessen-Symbol: Theme-Regeln button{padding:11px 15px} + svg{max-width:100%} drueckten es auf wenige px
    // (Handy-Meldung 25.09.2026) — Innenabstand 0, Symbol feste Groesse, sichtbare Kreisflaeche.
    '.r24lp .r24lp__x{padding:0;margin:0;min-width:0;background:#f2f4f3;color:var(--r24h-ink,#16181d)}' +
    '.r24lp .r24lp__x svg{width:18px;height:18px;max-width:none;flex-shrink:0;display:block}' +
    '.r24lp-scrim{display:none}' +
    // Produktseite/Warenkorb: unten links ueber der Kaufleiste (Abstand setzt place()), nie oben ueber der Galerie.
    '.r24lp.r24lp--low{top:auto!important;bottom:16px;transform-origin:bottom left}.r24lp.r24lp--low:not(.is-in){transform:translateY(8px) scale(.985)}' +
    // Mobil: unteres Blatt, NICHT-MODAL (docs/KONTO-LOGIN.md §4) — seit 02.10.2026 ohne Abdunkelung und hoechstens
    // 62 % der Bildschirmhoehe (vorher 52 % dunkler Grund ueber ⅔ der Produktseite); die Seite bleibt bedienbar.
    // E-Mail-Zeile untereinander, Browser-Tipp entfaellt (spart eine Zeile).
    // Ebene 469/470: ueber Kopf (200) und der Kaufleiste der Produktseite (.r24pd-sticky 460) —
    // vorher lag die Kaufleiste ueber dem Blatt und schnitt dessen Ende ab (Handy-Pruefung 01.10.2026).
    '@media (max-width:749px){.r24lp{left:8px;right:8px;width:auto;padding:18px 16px 12px;border-radius:16px}' +
    '.r24lp{left:0;right:0;top:auto!important;bottom:0;z-index:470;max-height:calc(100vh - 48px);max-height:min(62dvh,calc(100dvh - 48px));overflow-y:auto;overscroll-behavior:contain;' +
    'border-radius:22px 22px 0 0;border:0;padding:26px 18px calc(14px + env(safe-area-inset-bottom,0px));' +
    'box-shadow:0 -12px 40px rgba(16,24,32,.28);transform:translateY(24px);transform-origin:bottom center}' +
    '.r24lp::before{inset:8px auto auto 50%;width:40px;height:4px;margin-left:-20px;border-radius:4px;background:#d5d9d7}' +
    '.r24lp__x{top:12px;right:12px;width:44px;height:44px}.r24lp .r24lp__x svg{width:20px;height:20px}' +
    '.r24lp__eye{margin-top:4px}.r24lp__tip{display:none}.r24lp__code{margin-top:10px;font-size:13px}' +
    '.r24lp__t{font-size:20px}.r24lp__d{margin-bottom:12px}.r24lp__row{flex-direction:column}.r24lp__go{width:100%}}' +
    '@media (prefers-reduced-motion:reduce){.r24lp,.r24lp-scrim{transition:none}.r24lp__sk{animation:none}}' +
    '.r24lw{position:fixed;z-index:130;left:50%;top:calc(env(safe-area-inset-top,0px) + 12px);transform:translateX(-50%);' +
    'display:flex;align-items:center;gap:10px;max-width:calc(100vw - 32px);box-sizing:border-box;padding:10px 8px 10px 16px;' +
    'background:#fff;border:var(--r24-hair,1px solid #e6e7ea);border-radius:999px;box-shadow:0 10px 30px rgba(16,24,32,.14);' +
    'font-family:var(--r24h-font,inherit);font-size:var(--r24-fs-sm,14px);color:var(--r24h-ink,#16181d)}' +
    '.r24lw a{color:var(--r24h-green,#0a7c42);font-weight:600}' +
    '.r24lw button{width:36px;height:36px;border:0;background:none;border-radius:999px;cursor:pointer;color:var(--r24h-muted,#5b6470)}';
  var cssDone = false;
  function ensureCss() {
    if (cssDone) return;
    cssDone = true;
    var st = document.createElement('style');
    st.setAttribute('data-r24-account', '');
    st.textContent = CSS;
    document.head.appendChild(st);
  }
  var LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
  // Anbieter-Logos (offizielle Markenzeichen, nur Darstellung) — WELCHE erscheinen, bestimmt Shopify (socialLoginProviders).
  var PROV = {
    google: { label: 'Weiter mit Google', icon: '<svg viewBox="0 0 48 48" aria-hidden="true"><path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/><path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/><path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/><path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/></svg>' },
    shop: { label: 'Mit <b>shop</b> anmelden', html: true, icon: '<svg viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="1.8" stroke-linejoin="round" aria-hidden="true"><path d="M5.5 8h13l-1.1 12.2H6.6z"/><path d="M9 10V7a3 3 0 0 1 6 0v3"/></svg>' },
    facebook: { label: 'Weiter mit Facebook', icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#fff" d="M24 12.07C24 5.4 18.63 0 12 0S0 5.4 0 12.07C0 18.1 4.39 23.1 10.13 24v-8.44H7.08v-3.49h3.04V9.41c0-3.02 1.8-4.7 4.54-4.7 1.31 0 2.68.24 2.68.24v2.97h-1.5c-1.5 0-1.96.93-1.96 1.89v2.26h3.33l-.53 3.5h-2.8V24C19.62 23.1 24 18.1 24 12.07z"/></svg>' },
    apple: { label: 'Weiter mit Apple', icon: '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="#fff" d="M16.4 12.6c0-2.6 2.1-3.8 2.2-3.9-1.2-1.8-3.1-2-3.7-2-1.6-.2-3.1.9-3.9.9-.8 0-2-.9-3.4-.9-1.7 0-3.3 1-4.2 2.6-1.8 3.1-.5 7.7 1.3 10.2.9 1.2 1.9 2.6 3.2 2.5 1.3-.1 1.8-.8 3.3-.8s2 .8 3.4.8c1.4 0 2.3-1.3 3.1-2.5 1-1.4 1.4-2.8 1.4-2.9 0 0-2.7-1-2.7-4zM13.9 4.9c.7-.9 1.2-2 1-3.2-1 0-2.3.7-3 1.6-.7.8-1.2 2-1.1 3.1 1.2.1 2.3-.6 3.1-1.5z"/></svg>' }
  };
  var ORDER = ['google', 'shop', 'facebook', 'apple'];
  var PROV_KEY = 'r24_login_prov';
  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var X = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  // Texte je Anlass. Nur Aussagen, die Shopify-Konten wirklich leisten — KEIN „Merkliste sichern“:
  // die Merkliste liegt nur im Browser (r24_wis_v), nicht am Kundenkonto (Folgeprojekt, docs/KONTO-LOGIN.md §9).
  var COPY = {
    site: ['Schneller einkaufen', 'Melden Sie sich bequem an und verwalten Sie Ihre Bestellungen.'],
    product: ['Schneller einkaufen', 'Melden Sie sich bequem an und verwalten Sie Ihre Bestellungen.'],
    cart: ['Schneller zur Kasse', 'Melden Sie sich bequem an und verwalten Sie Ihre Bestellungen.']
  };

  function welcome() {
    var go = function () {
      ensureCss();
      var w = document.createElement('div');
      w.className = 'r24lw';
      w.setAttribute('role', 'status');
      // Ohne Vornamen (typisch nach E-Mail-Code) KEINE leere Anrede — nur „Willkommen zurück“.
      var txt = firstName ? 'Willkommen zurück, ' + firstName + '!' : 'Willkommen zurück!';
      w.innerHTML = '<span></span>' + (profileIncomplete && profileUrl ? '<a href="">Profil vervollständigen</a>' : '') +
        '<button type="button" aria-label="Hinweis schließen">' + X + '</button>';
      w.firstChild.textContent = txt;            // Name nie als HTML
      var link = w.querySelector('a'); if (link) link.href = profileUrl;
      var kill = function () { if (w.parentNode) w.parentNode.removeChild(w); };
      w.querySelector('button').addEventListener('click', kill);
      document.body.appendChild(w);
      setTimeout(kill, 7000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
  }

  /* ---------------------------------------------------------- Hinweis -- */
  var box = null, scrim = null, shownCtx = '';
  function renderPrompt(ctx) {
    ensureCss();
    var c = COPY[ctx] || COPY.site;
    box = document.createElement('div');
    box.className = low ? 'r24lp r24lp--low' : 'r24lp';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'false');
    box.setAttribute('aria-labelledby', 'r24lp-t');
    box.setAttribute('aria-describedby', 'r24lp-d');
    box.innerHTML =
      '<button type="button" class="r24lp__x" data-r24lp-close aria-label="Hinweis schließen">' + X + '</button>' +
      '<p class="r24lp__eye">' + LOCK + '<span>Sicher anmelden</span></p>' +
      '<h2 class="r24lp__t" id="r24lp-t"></h2><p class="r24lp__d" id="r24lp-d"></p>' +
      '<div class="r24lp__prov" data-r24lp-prov aria-busy="true"><div class="r24lp__sk"></div><div class="r24lp__sk"></div></div>' +
      '<div class="r24lp__or">oder mit E-Mail-Code</div>' +
      '<form class="r24lp__f" data-r24lp-mail novalidate>' +
      '<label class="r24lp__lbl" for="r24lp-mail">E-Mail-Adresse</label>' +
      '<div class="r24lp__row"><input class="r24lp__in" id="r24lp-mail" type="email" name="email" autocomplete="email" inputmode="email"' +
      ' autocapitalize="off" spellcheck="false" placeholder="E-Mail-Adresse" aria-describedby="r24lp-tip r24lp-code">' +
      '<button type="submit" class="r24lp__go">Code senden</button></div>' +
      '<p class="r24lp__err" id="r24lp-err" role="alert" hidden>Bitte eine gültige E-Mail-Adresse eingeben.</p>' +
      '<p class="r24lp__tip" id="r24lp-tip">Tipp: Ins Feld tippen – Ihr Browser schlägt Ihre gespeicherte E-Mail-Adresse vor.</p>' +
      '</form>' +
      '<p class="r24lp__code" id="r24lp-code">' + TICK + '<span>Sie erhalten einen 6-stelligen Code per E-Mail. Kein Passwort nötig – ' +
      'neue Kundinnen und Kunden erhalten so automatisch ein Konto.</span></p>' +
      '<div class="r24lp__foot"><button type="button" class="r24lp__later" data-r24lp-close>Später</button>' +
      '<p class="r24lp__fine">Newsletter nur, wenn Sie ihn selbst auswählen.</p></div>';
    box.querySelector('.r24lp__t').textContent = c[0];
    box.querySelector('.r24lp__d').textContent = c[1];
    providers(function (list) { renderProviders(list); });
    box.querySelector('[data-r24lp-mail]').addEventListener('submit', function (e) {
      e.preventDefault();
      var inp = box && box.querySelector('#r24lp-mail'), err = box && box.querySelector('#r24lp-err');
      var v = inp ? String(inp.value || '').trim() : '';
      if (!MAIL_RE.test(v)) {
        if (inp) { inp.setAttribute('aria-invalid', 'true'); try { inp.focus(); } catch (x) { /* egal */ } }
        if (err) err.hidden = false;
        return;
      }
      // Nur Quelle/Weg melden — die Adresse selbst geht ausschliesslich an Shopifys Anmeldung.
      emit('login_prompt_cta', { source: 'smart_prompt', trigger: shownCtx });
      markPending('smart_prompt', shownCtx, 'email_code');
      emit('login_start', startData('smart_prompt', shownCtx, 'email_code'));
      location.href = loginUrl + (loginUrl.indexOf('?') > -1 ? '&' : '?') + 'login_hint=' + encodeURIComponent(v);
    });
    box.addEventListener('click', function (e) {
      var pb = e.target.closest('[data-r24lp-prov-btn]');
      if (pb) {
        var h = pb.getAttribute('data-r24lp-prov-btn');
        emit('login_prompt_cta', { source: 'smart_prompt', trigger: shownCtx });
        markPending('smart_prompt', shownCtx, h);
        emit('login_start', startData('smart_prompt', shownCtx, h));
        // Shopifys Anmelde-Route (routes.storefront_login_url) + OIDC-Standard acr_values — genau so startet auch
        // Shopifys eigenes Login-Formular einen Anbieter. Kennt Shopify ihn nicht, zeigt es seine Anmeldeseite.
        location.href = loginUrl + (loginUrl.indexOf('?') > -1 ? '&' : '?') + 'acr_values=' + encodeURIComponent('provider:' + h);
        return;
      }
      if (e.target.closest('[data-r24lp-go]')) {
        emit('login_prompt_cta', { source: 'smart_prompt', trigger: shownCtx });
        open('smart_prompt', shownCtx);
        return;
      }
      if (e.target.closest('[data-r24lp-close]')) hidePrompt(true);
    });
    // Mobil (CSS ≤ 749 px) sichtbar: Abdunkelung hinter dem Blatt; Tippen darauf schliesst wie „Später“.
    scrim = document.createElement('div');
    scrim.className = 'r24lp-scrim';
    scrim.setAttribute('data-r24lp-close', '');
    scrim.setAttribute('aria-hidden', 'true');
    scrim.addEventListener('click', function () { hidePrompt(true); });
    document.body.appendChild(box);
    document.body.appendChild(scrim);
    place();
    if (low) setTimeout(schedule, 450);
    // Einblenden: rAF, mit Zeitgeber als Rueckfall (rAF ruht in verdeckten Tabs — sonst bliebe opacity 0).
    var shown = function () { if (box) box.classList.add('is-in'); if (scrim) scrim.classList.add('is-in'); };
    if (window.requestAnimationFrame) requestAnimationFrame(function () { requestAnimationFrame(shown); });
    setTimeout(shown, 60);
  }
  /* Aktive Anmeldewege von Shopify (Storefront API, oeffentlich, dieselbe Abfrage wie shopify-account):
     z. B. ["Shop","Google"]; Facebook erscheint automatisch, sobald es im Admin aktiv ist. 1× je Besuch abgefragt
     (sessionStorage), nur wenn der Hinweis erscheint — nie auf Verdacht. */
  function providers(cb) {
    var cached = read('sessionStorage', PROV_KEY);
    if (cached && Array.isArray(cached.h)) { cb(cached.h); return; }
    r24Fetch('/api/2026-01/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: '{ shop { socialLoginProviders { handle } } }' }) }, false, 6000).then(function (res) {
      var list = null;
      try { list = res.data.data.shop.socialLoginProviders.map(function (p) { return String(p.handle || '').toLowerCase(); }); }
      catch (e) { list = null; }
      if (list) write('sessionStorage', PROV_KEY, { h: list });
      cb(list);
    });
  }
  function renderProviders(list) {
    var el = box && box.querySelector('[data-r24lp-prov]');
    if (!el) return;
    var html = '';
    (list || []).length && ORDER.forEach(function (h) {
      if (list.indexOf(h) < 0 || !PROV[h]) return;
      var p = PROV[h];
      html += '<button type="button" class="r24lp__pb r24lp__pb--' + h + '" data-r24lp-prov-btn="' + h + '"' +
        (p.html ? ' aria-label="Mit Shop anmelden"' : '') + '>' + p.icon + '<span>' + p.label + '</span></button>';
    });
    // Keine Liste (Netz/Fehler): EIN Knopf zu Shopifys Fenster — dort stehen alle Wege.
    if (!html) html = '<button type="button" class="r24lp__pb r24lp__pb--more" data-r24lp-go>Mit Shop, Google &amp; mehr anmelden</button>';
    el.innerHTML = html;
    el.removeAttribute('aria-busy');
  }
  // Abrufregel (CLAUDE.md): wortgleiche Kopie von r24Fetch — nie throw, JSON nur bei JSON-Body, Zeitlimit, console.warn.
  function r24Fetch(url, init, retry, ms){
    var ctl = typeof AbortController === 'function' ? new AbortController() : null, tm = 0, o = {}, k;
    for (k in (init || {})) o[k] = init[k];
    if (ctl){ o.signal = ctl.signal; tm = setTimeout(function(){ ctl.abort(); }, ms || 20000); }
    return fetch(url, o).then(function(r){
      return r.text().then(function(t){
        clearTimeout(tm);
        var d = null, s = r.status, wait;
        if (/^\s*[\[{]/.test(t || '')){ try { d = JSON.parse(t); } catch (e) { d = null; } }
        if (s === 429 && retry){
          wait = Math.min(4, Math.max(1, parseFloat(r.headers && r.headers.get('Retry-After')) || 1.5));
          return new Promise(function(go){ setTimeout(go, wait * 1000); }).then(function(){ return r24Fetch(url, init, false, ms); });
        }
        return { ok: r.ok, status: s, data: d, text: t || '', url: r.url || '',
          kind: r.ok ? (d ? 'ok' : 'empty') : s === 429 ? 'rate' : s >= 500 ? 'server' : 'client' };
      });
    }).then(null, function(e){
      clearTimeout(tm);
      var to = !!(e && e.name === 'AbortError');
      if (typeof console !== 'undefined') console.warn('[R24] ' + url + ': ' + (to ? 'Zeitlimit' : (e && e.message) || e));
      return { ok: false, status: 0, data: null, text: '', url: '', kind: to ? 'timeout' : 'network' };
    });
  }

  /* Oben links direkt unter dem (klebenden) Kopf — gut sichtbar, ohne ihn zu verdecken. Der Kopf gleitet
     beim Runterscrollen weg (is-hidden): dann rueckt der Hinweis nach oben. Nur solange er offen ist,
     bei Scroll/Resize (1× je Frame). */
  function headerBottom() {
    var h = document.querySelector('.r24hd-sticky') || document.querySelector('#r24hd');
    if (!h || !h.getBoundingClientRect) return 0;
    var r = h.getBoundingClientRect();
    return r.bottom > 0 ? Math.round(r.bottom) : 0;
  }
  // Oberkante der klebenden Kaufleiste der Produktseite (0 = nicht sichtbar).
  function buyBarTop() {
    var b = document.querySelector('.r24pd-sticky');
    if (!b || !b.getBoundingClientRect) return 0;
    var r = b.getBoundingClientRect(), vh = window.innerHeight || 0;
    return r.height > 0 && r.top < vh ? Math.round(r.top) : 0;
  }
  var placing = 0;
  function place() {
    placing = 0;
    if (!box) return;
    try {
      if (!low) { box.style.top = (headerBottom() + 12) + 'px'; return; }
      // Unten: ueber der klebenden Kaufleiste (PDP) — der Kaufknopf bleibt frei; Handy ohne Luecke (Blatt).
      var vh = window.innerHeight || 0, bar = buyBarTop(), off = bar ? Math.max(0, vh - bar) : 0;
      var mob = device() === 'mobile';
      box.style.bottom = (off + (mob ? 0 : 16)) + 'px';
      if (mob && vh) box.style.maxHeight = Math.max(240, Math.min(Math.round(vh * 0.62), vh - off - headerBottom() - 12)) + 'px';
    }
    catch (e) { warn('Position', e); }
  }
  function schedule() { if (box && !placing) placing = (window.requestAnimationFrame || setTimeout)(place); }
  // Die Kaufleiste gleitet erst NACH dem Scroll-Ereignis herein (Uebergang) → einmal danach nachziehen.
  var late = 0;
  function scheduleLate() { schedule(); if (box && low) { clearTimeout(late); late = setTimeout(schedule, 450); } }
  window.addEventListener('scroll', scheduleLate, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  function hidePrompt(dismissed) {
    if (!box) return;
    var b = box;
    box = null;
    if (dismissed) {
      // Geschlossen → in diesem Besuch auf keiner Seite mehr (naechster Besuch = neue Sitzung).
      var st = read('sessionStorage', S_KEY) || {};
      st.closed = 1;
      write('sessionStorage', S_KEY, st);
      emit('login_prompt_close', { source: 'smart_prompt', trigger: shownCtx });
      // Fokus lag im Hinweis → nicht ins Leere fallen lassen
      if (b.contains(document.activeElement)) { try { document.body.focus(); } catch (e) { /* egal */ } }
    }
    b.parentNode && b.parentNode.removeChild(b);
    if (scrim) { scrim.parentNode && scrim.parentNode.removeChild(scrim); scrim = null; }
  }
  document.addEventListener('keydown', function (e) {
    if (box && (e.key === 'Escape' || e.key === 'Esc')) hidePrompt(true);
  });

  /* ------------------------------------------------ nach der Anmeldung -- */
  var pending = read('sessionStorage', C_KEY);
  if (isCustomer) {
    if (pending && Date.now() - (pending.t || 0) < PENDING_MS) {
      var ok = { source: pending.s || '', method: pending.m || 'unknown' };
      if (pending.g) ok.trigger = pending.g;
      emit('login_success', ok);
      welcome();
    }
    write('sessionStorage', C_KEY, null);
    return;   // eingeloggt: kein Hinweis, keine Ausloeser
  }

  /* ------------------------------------------------------------ Politik -- */
  function busy() {
    // Nie ueber anderen Ebenen: Mobil-Schublade, native Konto-Fenster, offene Dialoge/Kalles-Drawer —
    // und nie gleichzeitig mit Shopifys Cookie-Banner (im Vorschau-Theme lag er ueber dem Hinweis).
    if (document.querySelector('#r24md.is-open, .t4s-drawer[aria-hidden="false"], dialog[open], .r24lp')) return true;
    var pc = document.getElementById && document.getElementById('shopify-pc__banner');
    if (pc && pc.getBoundingClientRect().height > 0) return true;
    var el = nativeEl();
    var r = el && el.shadowRoot;
    return !!(r && r.querySelector('dialog[open]'));
  }
  // Anlass dieser Seite: Produktseite, Warenkorb oder sonstige Shop-Seite.
  var pageCtx = template === 'product' ? 'product' : (template === 'cart' ? 'cart' : 'site');
  var low = pageCtx !== 'site';   // Produktseite/Warenkorb: Interessen-Regel + Lage unten
  /**
   * Darf der Hinweis JETZT automatisch erscheinen? (Owner-Regel 24.09.2026, je Besuch)
   * Nur Gaeste, nie Editor/Konto/Passwort/Gutschein; nicht nach Schliessen in diesem Besuch;
   * jeder Anlass (site/product/cart) hoechstens einmal je Besuch; je Seite hoechstens einmal (box/fired).
   */
  function shouldAutoShow(ctx) {
    if (designMode || box) return false;
    if (/^(customers|password|gift_card)/.test(template)) return false;
    if (document.querySelector('[data-r24-noprompt]')) return false;   // Planer: Kunde arbeitet — der Hinweis verdeckte am Handy die halbe Planung (Runde 36)
    var st = read('sessionStorage', S_KEY) || {};
    return !st.closed && !st[ctx];
  }
  var BUSY_RETRY_MS = 15000;
  /** true = gezeigt; 'busy' = nur gerade belegt (einmal spaeter erneut); false = Regel sagt nein. */
  function show(ctx) {
    if (!shouldAutoShow(ctx)) return false;
    if (busy()) return 'busy';
    var st = read('sessionStorage', S_KEY) || {};
    st[ctx] = 1;
    st.site = 1;      // Produkt/Warenkorb zaehlen auch als „Shop betreten“ → auf der naechsten Seite kein zweites „site“
    write('sessionStorage', S_KEY, st);
    shownCtx = ctx;
    renderPrompt(ctx);
    emit('login_prompt_view', { source: 'smart_prompt', trigger: ctx, variant: returning ? 'returning' : 'new' });
    return true;
  }
  // Belegt (Cookie-Banner, Schublade …): erscheint direkt nach der Cookie-Entscheidung (Shopify-Ereignis
  // visitorConsentCollected) bzw. einmal nach BUSY_RETRY_MS — ein Ereignis + ein Zeitgeber, kein Polling.
  function showOrRetry(ctx) {
    if (show(ctx) !== 'busy') return;
    var done = false;
    var again = function () {
      if (done) return;
      if (!interested()) { done = true; fired = false; return; }   // verdeckt gerade Galerie/Kaufknopf → naechstes Scrollen
      if (show(ctx) !== 'busy') done = true;
    };
    document.addEventListener('visitorConsentCollected', function () { setTimeout(again, 800); }, { once: true });
    setTimeout(again, BUSY_RETRY_MS);
  }

  /* ------------------------------------------------------------ Ausloeser -- */
  // Wiederkehrend (nur fuer die Auswertung „variant“) = eigene Spuren frueherer Besuche (Merkliste, letzte Suchen).
  var returning = (function () {
    try {
      var w = JSON.parse(localStorage.getItem('r24_wis_v') || '[]');
      return !!((Array.isArray(w) && w.length) || localStorage.getItem('r24_recent_q'));
    } catch (e) { return false; }
  })();

  // Ein einzelner Zeitgeber: DELAY_MS sichtbare Zeit auf dieser Seite, dann EIN Versuch fuer den Anlass der Seite
  // (nur solange der Tab sichtbar ist — kein Intervall, kein Netz).
  var visibleMs = 0, since = 0, timer = 0, fired = false;
  function elapsed() { return visibleMs + (since ? Date.now() - since : 0); }
  function scrolled() {
    var d = document.documentElement, y = window.scrollY || window.pageYOffset || 0;
    var max = d ? (d.scrollHeight || 0) - (window.innerHeight || 0) : 0;
    return max > 0 ? y / max : 0;
  }
  // Wuerde der Hinweis (unten links, geschaetzte Groesse) Galerie oder Kaufknopf verdecken?
  var GUARD = '.r24pd-stage, .r24pd-thumbs, form[action*="/cart/add"] [type="submit"], [name="checkout"]';
  function covers() {
    var vh = window.innerHeight || 0, vw = window.innerWidth || 0;
    if (!vh || !vw || !document.querySelectorAll) return false;
    var mob = device() === 'mobile', bar = buyBarTop(), b = (bar || vh) - (mob ? 0 : 16);
    var a = { l: mob ? 0 : 16, r: mob ? vw : 16 + Math.min(392, vw - 32), t: b - Math.min(mob ? vh * 0.62 : 560, vh), b: b };
    var els = document.querySelectorAll(GUARD);
    for (var i = 0; i < els.length; i++) {
      var r = els[i].getBoundingClientRect && els[i].getBoundingClientRect();
      if (r && r.width > 0 && r.height > 0 && r.left < a.r && a.l < r.right && r.top < a.b && a.t < r.bottom) return true;
    }
    return false;
  }
  function interested() {
    if (!low) return true;
    return (scrolled() >= INTEREST_SCROLL || elapsed() >= INTEREST_MS) && !covers();
  }
  function check() {
    timer = 0;
    if (fired || document.hidden) return;
    var rest = DELAY_MS - elapsed();
    if (rest > 0) { timer = setTimeout(check, rest); return; }
    if (!interested()) {
      // noch kein Interesse: einmal zur 25-s-Marke; sonst entscheidet das naechste Scrollen
      var r2 = INTEREST_MS - elapsed();
      if (r2 > 0) timer = setTimeout(check, r2);
      return;
    }
    fired = true;
    showOrRetry(pageCtx);
  }
  // Scrollen auf Produktseite/Warenkorb prueft erneut (1× je Frame, nur solange noch nichts gezeigt wurde).
  var sPend = 0;
  if (low) window.addEventListener('scroll', function () {
    if (fired || sPend || document.hidden) return;
    sPend = (window.requestAnimationFrame || setTimeout)(function () {
      sPend = 0;
      if (fired || document.hidden || elapsed() < DELAY_MS) return;
      if (timer) { clearTimeout(timer); timer = 0; }
      check();
    });
  }, { passive: true });
  function arm() { if (!timer && !fired) check(); }
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      if (since) visibleMs += Date.now() - since;
      since = 0;
      if (timer) { clearTimeout(timer); timer = 0; }
    } else { since = Date.now(); arm(); }
  });
  if (!document.hidden) { since = Date.now(); arm(); }
})();
